export var DndExplorerType = 'EXPLORER';